import { ModalBody, ModalHeader, Button, ModalFooter } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'
import NumberInput from 'react-number-format'

import { optionsSendLinkMethod } from './constants'
import RadioButton from '../../../common-components/radio-button-group'
import { getRemoteSellingState } from 'e-submission/domain/data-model/form/selectors'
import { getCurrentApp } from '../../apps/selectors'
import {
  setEmailRemoteSelling,
  setPhoneNumberRemoteSelling,
  setSendingMethodRemoteSelling,
  closeSendingLinkModalRemoteSelling,
} from '../../apps/actions'
import createTextInput from '../../components/Form/Input/TextInput'
import { Modal } from '../../../common-components'
import { renderErrorMessage } from 'common-components/view-logic'
import { validateEmail } from 'e-submission/utils'
import { validateSendLinkInputPopup } from 'e-submission/domain/data-model/form/validation'

const TextInput = createTextInput()

function isEnableSubmitButton(sendingMethod, email, sms) {
  if (sendingMethod === 'sms') {
    return sms && sms.length === 10
  }

  return validateEmail(email)
}
export const SendLinkRoomIdNotExist = (props) => {
  const dispatch = useDispatch()
  const app = useSelector((state) => getCurrentApp(state))
  const remoteSellingState = getRemoteSellingState(app) || {}
  const sms = remoteSellingState.sms
  const email = remoteSellingState.email
  const method = remoteSellingState.sendingMethod
  const textInput = remoteSellingState.sendingMethod === 'sms' ? sms : email
  const isValid = isEnableSubmitButton(method, email, sms)

  const validateInput = validateSendLinkInputPopup({ textInput }, method)

  const isOpen = remoteSellingState.isLinkModalOpen

  const setEmail = (email) => dispatch(setEmailRemoteSelling(email))
  const setPhoneNumber = (phoneNumber) => dispatch(setPhoneNumberRemoteSelling(phoneNumber))
  const setMethod = (method) => dispatch(setSendingMethodRemoteSelling(method))
  const closeModal = () => dispatch(closeSendingLinkModalRemoteSelling())

  return (
    <Modal isOpen={isOpen} backdrop={true} size="md" modalClassName="default-bootstrap remote-selling-modal">
      <ModalHeader
        toggle={() => {
          closeModal()
        }}
      >
        ส่งลิงก์ให้ผู้ขอประกันเพื่อทำ Remote Selling
      </ModalHeader>
      <ModalBody>
        กรุณาเลือกช่องทางการส่งลิงก์เพื่อทำ Remote Selling
        <div className={`form-group ${!isValid ? 'has-danger' : ''}`}>
          <RadioButton options={optionsSendLinkMethod} value={method} onChange={(e) => setMethod(e)} />
          {method === 'email' ? (
            <TextInput value={email} setValue={setEmail} />
          ) : (
            <NumberInput
              value={sms}
              format={'##########'}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className="form-control"
            />
          )}
          {isValid ? null : renderErrorMessage('validate-method-error-message')(validateInput, 'VALIDATION')}
          <div
            style={{ minWidth: '100%' }}
            className="validation-message attached-icon info-message-wrap form-control-feedback"
          >
            <p>ท่านสามารถเลือกช่องทางในการส่งลิงก์ผ่านทางช่องทางที่ท่านต้องการ</p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter style={{ justifyContent: 'center' }}></ModalFooter>
    </Modal>
  )
}

export default SendLinkRoomIdNotExist
